<div *ngIf="!(showNav | async)">
    <perfect-scrollbar>
        <div class="d-flex flex-row justify-content-center mt-5">
            <div class="p-2">
                <app-loading-button (click)="toggleCreation('medical')" classes="btn btn-primary loading-btn">
                    {{ 'company.profiles.create-medical' | translate }}
                </app-loading-button>
            </div>
            <div class="p-2">
                <app-loading-button (click)="toggleCreation('management')" classes="btn btn-primary loading-btn">
                    {{ 'company.profiles.create-management' | translate }}
                </app-loading-button>
            </div>
        </div>
        <div class="mt-3">
            <table>
                <thead>
                    <tr class="text-uppercase">
                        <td translate="company.profiles.header.profile"></td>
                        <td translate="company.profiles.header.type"></td>
                        <td translate="company.profiles.header.users"></td>
                    </tr>
                </thead>
                <tbody>
                    <tr (click)="editProfile(p)" *ngFor="let p of profiles">
                        <td>
                            <span><img [src]="'assets/image/' + p.iconName + '.svg'" class="iconName" alt="icon" /></span>
                            <span class="ms-1">{{ p.name }}</span>
                        </td>
                        <td [translate]="'company.profiles.type.' + p.type"></td>
                        <td class="ps-2">{{ p.activeUsersCount }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </perfect-scrollbar>
</div>
<div *ngIf="showNav | async">
    <router-outlet></router-outlet>
</div>
